module.exports = __webpack_public_path__ + "img/doc.b52edd0a.svg";